export const isValidDniOrRuc = (input: string): boolean => {
  const dniRegex = /^\d{8}$/
  const rucRegex = /^\d{11}$/

  // Validar DNI (8 dígitos)
  if (dniRegex.test(input)) {
    return true
  }

  // Validar RUC (11 dígitos con validación de suma)
  if (rucRegex.test(input)) {
    const digits = input.split('').map(Number)

    // Algoritmo para RUC válido
    const multipliers = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2]
    const sum = multipliers.reduce((acc, mult, index) => acc + mult * digits[index], 0)

    const remainder = sum % 11
    const checkDigit = 11 - remainder
    const expected = checkDigit === 10 ? 0 : checkDigit === 11 ? 1 : checkDigit

    if (digits[10] === expected) {
      return true
    }
  }

  return false
}
